var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_content"},[_c('div',{staticClass:"breadcrumbs"}),_c('div',{staticClass:"settings"},[_c('config-bar',{staticClass:"settings_bar"}),_c('v-sheet',{staticClass:"settings_main",class:{ 'settings_main--fit': _vm.fit }},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }